module.exports = __webpack_public_path__ + "static/media/competency-assessment-edit-new.611d5051.svg";